export enum PermissionType {
    OWNER = "owner",
    READ = "read",
    WRITE = "write",
    COPY = "copy",
    PLAYBACK = "playback",
    PUBLIC = "public",
    DOWNLOAD = "download",
    IGNORE = "ignore" // This will skip the permission check.
}
